export const resolveIconTextVariant = (size) => {
    let variantValue;
    switch (size) {
        case 'large':
            variantValue = 'small--large';
            break;
        case 'medium':
            variantValue = 'small--regular';
            break;
        case 'small':
            variantValue = 'xsmall--regular';
            break;
        case 'xsmall':
            variantValue = 'xsmall--small';
            break;
        default:
            variantValue = undefined;
    }
    return variantValue;
};
